import "core-js/modules/es.array.push.js";
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { showNotify } from "vant";
import { getMac } from '@/api/addLock';
import Bus from "@/utils/eventBus";
const mac = ref("");
export default defineComponent({
  name: "addLockQuery",
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const onSubmit = () => {
      if (!mac.value) {
        showNotify({
          type: "warning",
          message: "mac地址不能为空"
        });
        return;
      }
      console.log("submit", mac.value);
      loading.value = true;
      getMac(mac.value).then(({
        code,
        msg,
        data
      }) => {
        if (code === 200) {
          // showNotify({ type: "success", message: msg });
          if (data !== null && data !== void 0 && data.lockId) {
            mac.value = "";
            router.push({
              path: "/addLock",
              query: {
                lockId: data === null || data === void 0 ? void 0 : data.lockId,
                lockMac: data === null || data === void 0 ? void 0 : data.lockMac
              }
            });
          } else {
            showNotify({
              type: "warning",
              message: "未查询到相关门锁信息！"
            });
          }
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const goto = () => {
      router.push({
        path: "/addLock/qr"
      });
    };
    return {
      mac,
      loading,
      onSubmit,
      goto
    };
  }
});
// const arr:string[] = sessionStorage.getItem('qrText')?.split('#') || []
// mac.value = arr.length ? arr[arr.length - 1] : '';
// console.log('qrText', arr.length ? arr[arr.length - 1] : '')
Bus.$on("qrChange", res => {
  if (res) {
    const arr = res.split('#') || [];
    mac.value = arr.length ? arr[arr.length - 1] : '';
  }
});